import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useEffect, useRef } from "react";

import AOS from 'aos';
import 'aos/dist/aos.css';


const HomeEcoSystem = () => {

   gsap.registerPlugin(useGSAP);
   gsap.registerPlugin(ScrollTrigger);


   useGSAP(() => {
      // ****************secfour************


      ScrollTrigger.matchMedia({
         "(min-width: 768px)": function () {

            gsap.set(".CrdStkItem", { rotationX: 50, scale: 1, });
            //  gsap.set(".CrdStkItem .CardDisOurIner", {  filter: "blur(5px)" });

            gsap.to(".CrdStkItem:nth-child(1)", {
               scale: 0.82,
               scrollTrigger: {
                  trigger: ".CrdStkItem:nth-child(2)",
                  start: "top bottom",
                  end: "bottom top",
                  scrub: true,
               }
            });
            gsap.to(".CrdStkItem:nth-child(1)", {
               rotationX: 0,
               scrollTrigger: {
                  trigger: ".CrdStkItem:nth-child(1)",
                  start: "top bottom",
                  end: "bottom center",
                  scrub: true,
               }
            });
            gsap.to(".CrdStkItem:nth-child(1) ", {
               rotationX: 0,
               scrollTrigger: {
                  trigger: ".CrdStkItem:nth-child(1)",
                  start: "top bottom",
                  end: "bottom center",
                  scrub: true,
               }
            });
            gsap.to(".CrdStkItem:nth-child(1) .CardDisOurIner", {
               filter: "blur(0px)",
               scrollTrigger: {
                  trigger: ".CrdStkItem:nth-child(1)",
                  start: "top bottom",
                  end: "bottom center",
                  scrub: true,
               }
            });

            gsap.to(".CrdStkItem:nth-child(2)", {

               scale: 0.85,
               scrollTrigger: {
                  trigger: ".CrdStkItem:nth-child(3)",
                  start: "top bottom",
                  end: "bottom top",
                  scrub: true,
               }
            });

            gsap.to(".CrdStkItem:nth-child(2)", {
               rotationX: 0,
               scrollTrigger: {
                  trigger: ".CrdStkItem:nth-child(2)",
                  start: "top bottom",
                  end: "bottom center",
                  scrub: true,
               }
            });
            gsap.to(".CrdStkItem:nth-child(2) .CardDisOurIner", {
               filter: "blur(0px)",
               scrollTrigger: {
                  trigger: ".CrdStkItem:nth-child(2)",
                  start: "top bottom",
                  end: "bottom center",
                  scrub: true,
               }
            });

            gsap.to(".CrdStkItem:nth-child(3)", {

               scale: 0.88,
               scrollTrigger: {
                  trigger: ".CrdStkItem:nth-child(4)",
                  start: "top bottom",
                  end: "bottom top",
                  scrub: true,
               }
            });
            gsap.to(".CrdStkItem:nth-child(3)", {
               rotationX: 0,
               scrollTrigger: {
                  trigger: ".CrdStkItem:nth-child(3)",
                  start: "top bottom",
                  end: "bottom center",
                  scrub: true,
               }
            });
            gsap.to(".CrdStkItem:nth-child(3) .CardDisOurIner", {
               filter: "blur(0px)",
               scrollTrigger: {
                  trigger: ".CrdStkItem:nth-child(3)",
                  start: "top bottom",
                  end: "bottom center",
                  scrub: true,
               }
            });

            gsap.to(".CrdStkItem:nth-child(4)", {

               scale: 0.91,
               scrollTrigger: {
                  trigger: ".CrdStkItem:nth-child(5)",
                  start: "top bottom",
                  end: "bottom top",
                  scrub: true,
               }
            });

            gsap.to(".CrdStkItem:nth-child(4)", {
               rotationX: 0,
               scrollTrigger: {
                  trigger: ".CrdStkItem:nth-child(4)",
                  start: "top bottom",
                  end: "bottom center",
                  scrub: true,
               }
            });
            gsap.to(".CrdStkItem:nth-child(4) .CardDisOurIner", {
               filter: "blur(0px)",
               scrollTrigger: {
                  trigger: ".CrdStkItem:nth-child(4)",
                  start: "top bottom",
                  end: "bottom center",
                  scrub: true,
               }
            });

            gsap.to(".CrdStkItem:nth-child(5)", {

               scale: 0.94,
               scrollTrigger: {
                  trigger: ".CrdStkItem:nth-child(6)",
                  start: "top bottom",
                  end: "bottom top",
                  scrub: true,
               }

            });
            gsap.to(".CrdStkItem:nth-child(5)", {
               rotationX: 0,
               scrollTrigger: {
                  trigger: ".CrdStkItem:nth-child(5)",
                  start: "top bottom",
                  end: "bottom center",
                  scrub: true,
               }
            });
            gsap.to(".CrdStkItem:nth-child(5) .CardDisOurIner", {
               filter: "blur(0px)",
               scrollTrigger: {
                  trigger: ".CrdStkItem:nth-child(5)",
                  start: "top bottom",
                  end: "bottom center",
                  scrub: true,
               }
            });
            gsap.to(".CrdStkItem:nth-child(6)", {

               scale: 0.98,
               scrollTrigger: {
                  trigger: ".CrdStkItem:nth-child(5)",
                  start: "top bottom",
                  end: "bottom top",
                  scrub: true,
               }


            });
            gsap.to(".CrdStkItem:nth-child(6)", {
               rotationX: 0,
               scrollTrigger: {
                  trigger: ".CrdStkItem:nth-child(6)",
                  start: "top bottom",
                  end: "bottom center",
                  scrub: true,
               }
            });
            gsap.to(".CrdStkItem:nth-child(6) .CardDisOurIner", {
               filter: "blur(0px)",
               scrollTrigger: {
                  trigger: ".CrdStkItem:nth-child(6)",
                  start: "top bottom",
                  end: "bottom center",
                  scrub: true,
               }
            });
         }
      });



      // function animation_text_1(element) {
      //    let newText = "";
      //    let theText = document.querySelector(element);
      //    for (let i = 0; i < theText.innerText.length; i++) {
      //       newText += "<span class='d-inline-block'>";
      //       if (theText.innerText[i] == " ") { newText += "&nbsp;" }
      //       else { newText += theText.innerText[i]; }
      //       newText += "</span>";
      //    }
      //    theText.innerHTML = newText;
      //    gsap.fromTo(element + " span", {
      //       opacity: 0,
      //       y: 90,
      //       filter: 'blur(10px)',
      //    }, {
      //       duration: 2,
      //       opacity: 1,
      //       y: 0,
      //       filter: 'blur(0px)',
      //       stagger: 0.03,
      //       ease: "elastic(1.2, 0.5)",
      //       scrollTrigger: {
      //          trigger: element,
      //          start: "top 50%", // start when the top of the <h1> reaches 70% down from the top of the viewport
      //          toggleActions: "restart none none reverse",
      //          //markers: true
      //       }
      //    });
      // }
      // animation_text_1(".ecoTx1");
      // animation_text_1(".ecoTx2");

   }, {});


   useEffect(() => {
      setInterval(() => {
         ScrollTrigger.refresh()
      }, [1500])

      AOS.init();
      AOS.refresh();

   }, [])


   return (
      <section className="IndSecfour" id="ecosystem">
         <div className="container container-cus1190">
            <div className="CmnHdDis">
               <h2 data-aos='fade-left' data-aos-duration="1000">
                  <span className="ecoTx1 noHl">Introducing ROU</span> <br /> <span className="ecoTx2">Ecosystem</span>
               </h2>
               <p className="ecoP" data-aos='fade-right' data-aos-duration="1000">
                  The ROU ecosystem integrates Web3 payments, DeFi, eCommerce,
                  trading, and real-world utilities, enabling seamless cryptocurrency
                  adoption in everyday transactions.
               </p>
            </div>
            <div className="StkAllCrds">
               <div className="CrdStkItem">
                  <div className="CardDisOur">
                     <img className="lht" src={require("../../../assets/images/olliii.png")} alt="" />
                     <img className="lht2" src={require("../../../assets/images/olliii.png")} alt="" />
                     <div className="CardDisOurIner">
                        <div className="row align-items-center">
                           <div className="col-xl-6">
                              <div className="CardImgDicImg">
                                 {/* <img className="img-fluid" src={require("../../../assets/pics/doplantrip.png")} alt="doplantrip" loading="lazy" /> */}
                                 <video preload="none" src={require("../../../assets/videos/doplan.mp4")} loop muted autoPlay playsInline className="img-fluid"></video>
                              </div>
                           </div>
                           <div className="col-xl-6">
                              <div className="CardDisOurCnt">
                                 <h2>The Ultimate Web3 Travel Platform</h2>
                                 <div className="ndmb-10">
                                    <img src={require("../../../assets/images/ecoim5.png")} alt="" />
                                 </div>

                                 <p>Doplan is a next-generation travel booking platform that integrates Web3
                                    payments, enabling users to book flights and hotels using cryptocurrency,
                                    including Routine Coin (ROU). By leveraging blockchain technology, Doplan
                                    ensures fast, secure, and decentralized transactions, eliminating the need
                                    for traditional banking intermediaries.</p>
                                 <p>
                                    What sets Doplan apart is its AI-driven price scanning technology, which
                                    compares rates across 180+ travel platforms to provide users with the lowest
                                    possible prices on flights and accommodations. This not only enhances
                                    affordability but also promotes transparency and efficiency in the travel
                                    industry.
                                 </p>
                                 <button className="btn cmbtn ndmt-20">Create now</button>
                              </div>
                           </div>
                        </div>
                     </div>

                  </div>
               </div>
               <div className="CrdStkItem">
                  <div className="CardDisOur">
                     <img className="lht" src={require("../../../assets/images/olliii.png")} alt="" />
                     <img className="lht2" src={require("../../../assets/images/olliii.png")} alt="" />
                     <div className="CardDisOurIner">
                        <div className="row align-items-center">
                           <div className="col-xl-6">
                              <div className="CardImgDicImg text-center">
                                 {/* <img className="img-fluid" src={require("../../../assets/pics/ecommerce.png")} alt="ecommerce" loading="lazy" /> */}
                                 <video preload="none" src={require("../../../assets/videos/doroutine.mp4")} loop muted autoPlay playsInline className="img-fluid"></video>
                              </div>
                           </div>
                           <div className="col-xl-6">
                              <div className="CardDisOurCnt">
                                 <h2>Web3-powered eCommerce platform</h2>
                                 <div className="ndmb-10">
                                    <img src={require("../../../assets/logos/doroutine.svg").default} alt="doroutine" loading="lazy" />
                                 </div>
                                 <p>Doroutine is a Web3-powered eCommerce platform that enables users to buy and
                                    sell products globally using cryptocurrency, including Routine Coin (ROU).
                                    By integrating decentralized payments, Doroutine eliminates costly
                                    intermediaries, ensuring faster, more secure, and borderless transactions
                                    for both buyers and sellers. What makes Doroutine unique is its
                                    profit-sharing model, where at least 20% of every sale contributes directly
                                    to the Routine ecosystem, strengthening token demand, liquidity, and
                                    long-term sustainability.</p>
                                 <p>
                                    With Doroutine, ROU holders gain real-world utility, while merchants and
                                    consumers enjoy a transparent, cost-effective, and crypto-friendly shopping
                                    experience. 🛒🌍🚀
                                 </p>
                                 <button className="btn cmbtn ndmt-20">Create now</button>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="CrdStkItem">
                  <div className="CardDisOur">
                     <img className="lht" src={require("../../../assets/images/olliii.png")} alt="" />
                     <img className="lht2" src={require("../../../assets/images/olliii.png")} alt="" />
                     <div className="CardDisOurIner">
                        <div className="row align-items-center">
                           <div className="col-xl-6">
                              <div className="CardImgDicImg text-center">
                                 {/* <img className="img-fluid" src={require("../../../assets/pics/payment-1.png")} alt="payment-1" loading="lazy" /> */}
                                 <video preload="none" src={require("../../../assets/videos/billroutine.mp4")} loop muted autoPlay playsInline className="img-fluid"></video>
                              </div>
                           </div>
                           <div className="col-xl-6">
                              <div className="CardDisOurCnt">
                                 <h2>Web3-powered payment platform</h2>
                                 <div className="ndmb-10">
                                    <img src={require("../../../assets/images/ecoim1.png")} alt="" />
                                 </div>
                                 <p>Billroutine is a Web3-powered payment platform that allows users to
                                    seamlessly pay daily utility bills using Routine Coin (ROU) and other
                                    cryptocurrencies.</p>
                                 <p>From mobile recharges, electricity bills, and toll payments to Grab wallet
                                    top-ups, True Money, and more, Billroutine simplifies everyday transactions
                                    with fast, secure, and decentralized payments. By integrating crypto into
                                    essential services,</p>
                                 <p>
                                    Billroutine enhances the real-world utility of ROU, driving adoption and
                                    making digital assets a convenient choice for everyday financial needs.
                                    🚀💡📱
                                 </p>
                                 <button className="btn cmbtn ndmt-20">Create now</button>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="CrdStkItem">
                  <div className="CardDisOur">
                     <img className="lht" src={require("../../../assets/images/olliii.png")} alt="" />
                     <img className="lht2" src={require("../../../assets/images/olliii.png")} alt="" />
                     <div className="CardDisOurIner">
                        <div className="row align-items-center">
                           <div className="col-xl-6">
                              <div className="CardImgDicImg text-center">
                                 {/* <img className="img-fluid" src={require("../../../assets/pics/exchange.png")} alt="exchange" loading="lazy" /> */}
                                 <video preload="none" src={require("../../../assets/videos/rtc-video.mp4")} loop muted autoPlay playsInline className="img-fluid"></video>
                              </div>
                           </div>
                           <div className="col-xl-6">
                              <div className="CardDisOurCnt">
                                 <h2>The Ultimate Centralized Exchange</h2>
                                 <div className="ndmb-10">
                                    <img src={require("../../../assets/logos/rtcbit.png")} alt="" />
                                 </div>
                                 <p>RTCbit is a secure, user-friendly centralized exchange supporting 25+
                                    blockchain networks, providing traders and investors with a comprehensive
                                    suite of financial services.</p>
                                 <p>
                                    Designed for both beginners and experienced traders, RTCbit offers spot
                                    trading, margin trading, futures, copy trading, staking, and crypto-backed
                                    loans, all with the lowest fees in the industry.
                                 </p>
                                 <p>
                                    With a focus on security and seamless usability, RTCbit ensures 100% fund
                                    protection, robust trading tools, and high liquidity, making it the go-to
                                    exchange for users looking for fast, efficient, and reliable crypto trading.
                                    By integrating Routine Coin (ROU) within the platform, RTCbit strengthens
                                    its ecosystem, offering enhanced liquidity, deeper market integration, and
                                    more real-world utility for ROU holders
                                 </p>
                                 <button className="btn cmbtn ndmt-20">Create now</button>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="CrdStkItem">
                  <div className="CardDisOur">
                     <img className="lht" src={require("../../../assets/images/olliii.png")} alt="" />
                     <img className="lht2" src={require("../../../assets/images/olliii.png")} alt="" />
                     <div className="CardDisOurIner">
                        <div className="row align-items-center">
                           <div className="col-xl-6">
                              <div className="CardImgDicImg">
                                 <img className="img-fluid" src={require("../../../assets/images/dicimg6.png")} alt="" />
                              </div>
                           </div>
                           <div className="col-xl-6">
                              <div className="CardDisOurCnt">
                                 <h2>The Ultimate Centralized Exchange</h2>
                                 <div className="ndmb-10">
                                    <img src={require("../../../assets/images/ecoim3.png")} alt="" />
                                 </div>
                                 <p>RoutineSwap is a decentralized, user-custodial exchange designed to provide a
                                    secure, transparent, and permissionless trading experience.
                                    Unlike centralized exchanges, RoutineSwap ensures that users retain full
                                    control of their funds by eliminating third-party intermediaries, reducing
                                    counterparty risks, and enhancing privacy. Thus,Routineswap will be one of
                                    the first decentralized exchange to implement peer-to-peer (P2P) trading in
                                    the Web3 ecosystem using blockchain-based escrow technology.</p>

                                 <button className="btn cmbtn ndmt-20">Create now</button>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="CrdStkItem">
                  <div className="CardDisOur">
                     <img className="lht" src={require("../../../assets/images/olliii.png")} alt="" />
                     <img className="lht2" src={require("../../../assets/images/olliii.png")} alt="" />
                     <div className="CardDisOurIner">
                        <div className="row align-items-center">
                           <div className="col-xl-6">
                              <div className="CardImgDicImg text-center">
                                 {/* <img className="img-fluid" src={require("../../../assets/pics/card.png")} alt="card" loading="lazy" /> */}
                                 <video preload="none" src={require("../../../assets/videos/roupay.mp4")} loop muted autoPlay playsInline className="img-fluid"></video>
                              </div>
                           </div>
                           <div className="col-xl-6">
                              <div className="CardDisOurCnt">
                                 <h2>The Ultimate Crypto-Powered Prepaid
                                    Debit Card</h2>
                                 <div className="ndmb-10">
                                    <img src={require("../../../assets/logos/roupay.png")} alt="roupay" loading="lazy" />
                                 </div>
                                 <p>Roupay is a prepaid physical debit card seamlessly topped up with Routine
                                    Coin (ROU), enabling users to spend globally in THB, USD, SGD, EURO, and
                                    other major currencies. Designed for international convenience, Roupay
                                    offers a secure, fast, and hassle-free way to use crypto for everyday
                                    transactions, whether shopping, dining, or traveling abroad..</p>

                                 <button className="btn cmbtn ndmt-20">Create now</button>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

            </div>
         </div>
      </section>
   )
}
export default HomeEcoSystem;